import _ from 'lodash';
import React from 'react';
import Chart from 'react-apexcharts';

const StackedBarChart = (props) => {
    const { chartOptions, chartSeries } = props;
    
    return (
        <Chart
            height={350}
            options={_.cloneDeep(chartOptions)}
            series={chartSeries.length ? _.cloneDeep(chartSeries) : [{ name: '', data: [] }]}
            type="bar"
            width='100%'
        />
    );
};

export default StackedBarChart;
